import './PostPlanCard.scss';

import { ProductOffering } from '@travelwin/core';

import { useBuyPlanHandler } from '../../hooks/useBuyPlanHandler';
import PlanCard from '../PlanCard';

const className = 'c-PostPlanCard';

type PostPlanCardProps = {
  plan: ProductOffering;
};

export const PostPlanCard = ({ plan }: PostPlanCardProps) => {
  const handleBuyPlan = useBuyPlanHandler();

  return (
    <div className={className}>
      <PlanCard
        planDetails={plan}
        showSubtitle
        fluid
        onBuyNowClick={() => handleBuyPlan({ product: plan })}
      />
    </div>
  );
};
